// Module
var code = "<input aria-label=\"Find values\" id=\"filter\" placeholder=\"Find values\" type=\"text\"> <div id=\"values\"></div> <style id=\"custom\"></style> ";
// Exports
module.exports = code;